import { ModalDialog } from '@/scripts/theme/modal-dialog'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class KlaviyoPopup extends ModalDialog {
	static override htmlSelector = 'klaviyo-popup'
	openAfter: number
	cacheKey: string
	openers?: NodeListOf<HTMLButtonElement>
	demoMode: boolean
	delayForAnimation: boolean
	constructor() {
		super()
		this.delayForAnimation = document.documentElement.classList.contains('pre-animation')
		this.openAfter = parseInt(q.ra(this, 'data-uc-open-after')) * 1000
		if (this.delayForAnimation) {
			this.openAfter = this.openAfter + 10000;
		}
		this.cacheKey = q.ra(this, 'data-uc-cache-key')
		this.demoMode = q.ra(this, 'data-uc-demo-mode') === 'true'
	}

	initializePopup() {
		if (this.isKeyDisabled() && !this.demoMode) return
		window.setTimeout(() => {
			this.show()
			//mediaLoader()
		}, this.openAfter)
	}

	override connectedCallback() {
		this.initializePopup()
	}

	override show(opener?: HTMLButtonElement) {
		this.removeAttribute('style')
		window.setTimeout(() => {
			super.show(opener)
		}, 2)
	}

	override hide() {
		super.hide()
		this.disableKey()
	}

	isKeyDisabled() {
		const disabledKey = window.localStorage.getItem('disable_klaviyo')
		if (!disabledKey) return false
		return disabledKey === this.cacheKey
	}

	disableKey() {
		window.localStorage.setItem('disable_klaviyo', this.cacheKey)
	}
}
